module.exports = __webpack_public_path__ + "static/media/how-covid-19-is-changing-food-shopping.a9f4a7fd.jpg";